<template>
  <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M14 2V8H20"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M10 12.5C10 12.5 10 11.5 10.5 11C11 10.5 12 10.5 12.5 11C13 11.5 13 12 12.5 12.5C12 13 11 13.5 11 14.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <circle cx="11" cy="16.5" r="0.5" fill="currentColor"></circle>
  </svg>
</template>

<script>
export default {
  name: 'FileIcon',
  props: {
    contentType: {
      type: String,
      default: '',
    },
  },
}
</script>
